// Cómo se NOMBRA un adjunto cuando se lo menciona con `@` en la caja del Agente, y qué
// menciones trae un texto — ADR-2026-09-21-la-arroba-menciona-los-adjuntos. Vive acá (y
// no en `chat-atlas`) porque lo usa el motor al armar el contexto del turno, además del
// menú. Puro: sin React ni Supabase (`agentAttachments` sólo como tipo).

import type { ChatAttachment } from './agentAttachments';
import type { ReferenciaEtiquetada } from './referenciasDeGeneracion';

/**
 * Las referencias de un pedido de IMAGEN con el nombre con que el usuario las menciona
 * (`@Remera oversize`): el backend reemplaza cada mención por el rótulo que el motor ve
 * delante de esa foto. Y, si el escritor ya dijo qué es cada foto subida, su etiqueta.
 * Nació en Redes (`generarEnRedes`) y la comparte la barra de Editar del visor
 * (ADR-2026-10-06-editar-con-referencias-y-escritor).
 */
export function conMenciones(
  refs: ReferenciaEtiquetada[],
  adjuntos: readonly ChatAttachment[],
  etiquetas: ReadonlyArray<{ adjuntoId: string; etiqueta: string }> = [],
): ReferenciaEtiquetada[] {
  return refs.map((r) => {
    const adjunto = r.adjuntoId ? adjuntos.find((a) => a.id === r.adjuntoId) : undefined;
    const mencion = adjunto ? nombreDeMencion(adjunto, adjuntos) : '';
    const etiqueta = r.tipo === 'adjunto' ? etiquetas.find((e) => e.adjuntoId === r.adjuntoId)?.etiqueta : undefined;
    return { ...r, ...(mencion ? { mencion } : {}), ...(etiqueta && !r.etiqueta ? { etiqueta } : {}) };
  });
}

const sinAcentos = (s: string): string => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Las imágenes sueltas no tienen nombre: se numeran en el orden en que están enganchadas,
 *  que es el orden en que el modelo las ve como bloques. Lo demás, por su nombre. */
export function nombreDeMencion(a: ChatAttachment, adjuntos: readonly ChatAttachment[]): string {
  if (a.kind !== 'image') return a.name;
  const imagenes = adjuntos.filter((x) => x.kind === 'image');
  return `Imagen ${imagenes.findIndex((x) => x.id === a.id) + 1}`;
}

/** Los nombres mencionados con `@` en un texto que son adjuntos enganchados, en el orden
 *  de los adjuntos y sin repetir. Se compara sin acentos ni mayúsculas. */
export function mencionesEn(texto: string, adjuntos: readonly ChatAttachment[]): string[] {
  const t = sinAcentos(texto);
  const out: string[] = [];
  for (const a of adjuntos) {
    const n = nombreDeMencion(a, adjuntos);
    if (n && !out.includes(n) && t.includes(`@${sinAcentos(n)}`)) out.push(n);
  }
  return out;
}
